var _line, _rect, _text, _rect2, _text2, _path, _circle, _circle2, _circle3, _circle4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEventVsInterpretation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 200,
    y1: 40,
    x2: 200,
    y2: 220,
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.3,
    strokeDasharray: "6 4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 100,
    width: 110,
    height: 80,
    rx: 8,
    stroke: "#38bdf8",
    strokeWidth: 1.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 125,
    y: 135,
    textAnchor: "middle",
    fill: "#38bdf8",
    fontSize: 12,
    fontFamily: "sans-serif"
  }, "Event")), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 100,
    width: 110,
    height: 80,
    rx: 8,
    stroke: "#fbbf24",
    strokeWidth: 1.5
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 275,
    y: 135,
    textAnchor: "middle",
    fill: "#fbbf24",
    fontSize: 11,
    fontFamily: "sans-serif"
  }, "Story")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 195 Q168 118 200 105 Q232 118 232 195 Q200 208 168 195 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 148,
    r: 4,
    fill: "#fafcfb"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 95,
    cy: 75,
    r: 2,
    fill: "#fbbf24"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 305,
    cy: 70,
    r: 1.5,
    fill: "#38bdf8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventVsInterpretation);
export default __webpack_public_path__ + "static/media/event-vs-interpretation.02d2f37534996d18582e6612081c58e6.svg";
export { ForwardRef as ReactComponent };